/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { tagName } from '@ember-decorators/component';
import { computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { or } from '@ember/object/computed';
import Component from '@ember/component';
import { task } from 'ember-concurrency';
import { VWB_ACTION_UPDATED } from 'cio/services/event-bus';

@tagName('')
export default class WaitUntil extends Component {
  @service api;
  @service apiErrors;
  @service actionSubjects;
  @service eventBus;
  @service visualWorkflowBuilder;

  actionAbstract = null;
  isAddingOrMoving = false;
  onSelect() {}
  onDeselect() {}
  onDeleteStarted() {}
  onDeleteConfirmed() {}

  @or('_saveDelay.isRunning', '_confirmSave.isRunning') _isSaving;

  _showConfirmModal = false;

  @computed('actionAbstract.action.id')
  get _subjects() {
    return this.actionSubjects.find(this.actionAbstract.action.id);
  }

  _saveDelay = task(
    {
      drop: true,
    },
    async () => {
      let hasSubjects = this._subjects.count > 0;

      if (hasSubjects && (this.actionAbstract.areConditionPathsDirty || this.actionAbstract.hasMinimizedDelay)) {
        this.set('_showConfirmModal', true);
      } else {
        await this._confirmSave.perform();
      }
    },
  );

  _confirmSave = task(
    {
      drop: true,
    },
    async () => {
      this.set('_showConfirmModal', false);

      try {
        let promise = this.actionAbstract.saveTask.perform();
        this.visualWorkflowBuilder.redrawConnectingLines();
        await promise;
        await this.actionAbstract.action.campaign.parseTree();
        this.eventBus.publish(VWB_ACTION_UPDATED, this.actionAbstract.action);
        this.onDeselect();
      } catch (e) {
        this.apiErrors.report(e);
        throw e;
      }
    },
  );
}
